import React, { useState } from 'react';
import GoogleMapReact from 'google-map-react';
import Select from 'react-select';

const AddressComponent = ({ item }) => {
    return (<div class="locator__item-content">
        <h3 class="locator__item-label">
            {item.DisplayTitle ? item.DisplayTitle : item.Title}
        </h3>
        <div class="locator__item-address">
            <div class="location__address">
                {
                    item.Address.Street ?
                        <div class="location__address-street">{item.Address.Street}</div> : ""
                }
                <div class="locator__address-citystate">
                    {
                        item.Address.City ?
                            <span class="location__address-city">{item.Address.City}</span> : ""
                    }
                    {
                        item.Address.StateCode ?
                            <span class="location__address-state">, {item.Address.StateCode}</span> : ""
                    }
                    {
                        item.Address.ZipCode ?
                            <span class="location__address-zip"> {item.Address.ZipCode}</span> : ""
                    }
                </div>

            </div>
        </div>

    </div>);
}

const PhoneNumberComponent = ({ item }) => {
    return (<div class="locator__item-phone">
        <div class="locator__item-label">Phone</div>
        <a href={"tel:" + item.PhoneNumber} class="locator__item-phone-number">{item.PhoneNumber}</a>
    </div>);
}

const MoreDetailButtonComponent = ({ url }) => {
    return (<div class="locator__item-detail">
        <a href={url} class="location__detail-link button button--outline">More Details</a>
    </div>);
}

const MapPinComponent = ({item}) => {  
  const dialogClassName = 'location__dialog';
  const markerClass = "location__marker";
  const ShowDetailBox = (urlName) => {
    //WE HIDE ANY DIALOG THAT'S OPEN
    var elements = document.getElementsByClassName(dialogClassName);
    var markers = document.getElementsByClassName(markerClass);

    for (var x = 0; x < markers.length; x++) {
      markers[x].classList.remove("active");
  }

    for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = 'none';
    }


    document.getElementById(`pin-${item.Id}`).classList.add("active");
    document.getElementById(`detail-${urlName}`).style.display = 'block';
  }


  if(item.IsHQ) {
      return (<div id={`pin-${item.Id}`} class={markerClass} style={{ transform: 'translateZ(0) translate(-16%, -16%)' }} onClick={ShowDetailBox.bind(this,item.UrlName)}>
          <svg class="icon icon-location-pin-hq" role="presentation" style={{ transform: 'inherit' }} focusable="false" aria-hidden="true">
    <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-location-pin-hq"></use>
    </svg>
    </div>
    );
  } else {
      return (<div id={`pin-${item.Id}`} class={markerClass} style={{ transform: 'translateZ(0) translate(-50%, -50%)' }} onClick={ShowDetailBox.bind(this, item.UrlName)}>
          <svg class="icon icon-location-pin" style={{ transform: 'inherit' }} role="presentation" focusable="false" aria-hidden="true">
        <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-location-pin"></use>
        </svg>
        </div>
    );  
  }

}

const MapMarkerComponent = ({ parameters }) => {
      const item = parameters.item;
      const dialogClassName = 'location__dialog';

    return (<div style={{ position: 'relative' }}>
      
            <MapPinComponent item={item}></MapPinComponent>
            <div class={dialogClassName} id={`detail-${item.UrlName}`}>
                    <AddressComponent item={item}></AddressComponent>
            <PhoneNumberComponent item={item}></PhoneNumberComponent>
            <MoreDetailButtonComponent url={parameters.url}></MoreDetailButtonComponent>
            </div>
        </div>);
}


function Locations() {
    const LocationSettings = document.getElementById("location-settings") && JSON.parse(document.getElementById("location-settings").innerHTML);
    const Services = LocationSettings.serviceTypes.split(';').map((item) => {
        var items = item.split(',');
        return { value: items[0], label: items[1] }
    });
    Services.unshift({ value: '', label: 'All Services' });

    const [result, setResult] = useState({});
    const [InitialLoadDone, setInitialLoadFlag] = useState(false);
    const [LatitudeAndLongitude, SetLatitudeAndLongitude] = useState('');
    const [GotGeoCoords, SetGotGeoCoords] = useState(false);
    const [ServiceFilter, SetServiceFilter] = useState('');
    const [Address, SetAddress] = useState('');
    const [IsSearching, SetIsSearching] = useState(false);
    const PageSize = 10;
    const MapCenter = { lat: 40.9312099, lng: -73.8987469 }; //Yonkers, NY
    const MapZoom = 10;
    const ApiUrl = '/api/location/';
    const radius = 15; //On search, limit to 15 mile radius

    const SearchLocations = (currentPageNumber = 1) => {
        SetIsSearching(true);
        let searchUri = ApiUrl;

        if (Address.length > 0) {
            searchUri += `search?isGeoLocation=true&radius=${radius}&isDuplicateSearch=false&address=${Address}&`;
        }
        else if (LatitudeAndLongitude.length > 0) {
            searchUri += `search?isGeoLocation=true&isDuplicateSearch=true&address=${LatitudeAndLongitude}&`;
        }
        else {
            searchUri += 'all-locations?';
        }

        if (ServiceFilter.length > 0) {
            searchUri += `serviceType=${ServiceFilter}&`;
        }

        searchUri += `pageSize=${PageSize}&pageNumber=${currentPageNumber}`;
        fetch(searchUri).then((response) => {
            setInitialLoadFlag(true);
            SetIsSearching(false);
            if (response.status === 200) 
            {
                return response.json();
            }
            else 
            {
                return response.text().then(text => { throw new Error(text) })
            }
        }).then((data) => {
            setResult(data);
        }).catch((error) => {
            setResult({});
            SetIsSearching(false);
            console.error(error);
        });
    };

    React.useEffect(() => {
        if (LatitudeAndLongitude !== '' && !GotGeoCoords) {
            SetGotGeoCoords(true);
            SearchLocations();
        }

    });

    const DisplayPageNumbers = (totalPages, pageNumber) => {
        const pageElements = [];
        const limit = parseInt(totalPages);

        if (limit > 1) {
            const previousPage = pageNumber - 1;
            if (previousPage > 0) {
                pageElements.push(<div class='pagination__item'><button type="button" class="pagination__link pagination__link--prev" onClick={SearchLocations.bind(this, previousPage)} title="Go to previous page of results"><svg class="icon" focusable="false" aria-hidden="true">
                  <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_back"></use>
              </svg></button></div>);
            } else {
                pageElements.push(<div class="pagination__item"><div class="pagination__link pagination__link--prev">
                <svg class="icon" focusable="false" aria-hidden="true">
                  <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_back"></use>
              </svg>
                </div></div>)
            }
        }

        for (let i = 1; i <= limit; i++) {

            if (i !== pageNumber) {
                pageElements.push(<div class='pagination__item'><button type='button' class='pagination__link' onClick={SearchLocations.bind(this, i)}>{i}</button></div>);
            } else {
                pageElements.push(<div class='pagination__item pagination__item--active'><div class="pagination__link ">{i}</div></div>);
            }
        }

        if (limit > 1) {
            const nextPage = pageNumber + 1;
            if (nextPage <= limit) {
                pageElements.push(<div class='pagination__item'><button type="button" class="pagination__link pagination__link--next" onClick={SearchLocations.bind(this, nextPage)} title="Go to next page of results">
                 <svg class="icon" focusable="false" aria-hidden="true">
                    <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_forward"></use>
                </svg>
                </button></div>);
            } else {
                pageElements.push(<div class="pagination__item">
                  <div class="pagination__link pagination__link--next">
                    <svg class="icon" focusable="false" aria-hidden="true">
                        <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-arrow_forward"></use>
                    </svg>
                  </div>
                </div>);
            }
        }

        return pageElements;
    }

    const GetGeoCoordinates = () => {
        navigator.geolocation.getCurrentPosition(function (position) {
            SetAddress('');
            SetServiceFilter('');
            SetLatitudeAndLongitude(`${position.coords.latitude},${position.coords.longitude}`);
        }, function () {
            //We set the lat and long to Yonkers
            SetLatitudeAndLongitude(`${MapCenter.lat},${MapCenter.lng}`);
        });
    }

    if (!InitialLoadDone) {
        GetGeoCoordinates();
    }

    const HandleTypeSelect = e => {
        SetServiceFilter(e.value);
    };

    const HandleAddressChange = (event) => {
        SetAddress(event.target.value);
    }

    const GetDetailPageUrl = (itemUrlName) => {
        return `${LocationSettings.locationDetailPage}/${itemUrlName}`;
    }

    const GetButtonTitle = () => {
        return IsSearching ? 'Searching...' : 'Search';
    }

    const keyPress = (e) => {
        if(e.keyCode === 13)
        {
            SearchLocations();
        }
    }

    return (<div class='locator'>
        <div class="locator__header">
            <div class="locator__filters-form" role="form" title="Locator Search">
                <div class="locator__filters">
                    <h2 class="locator__filters-title">
                        <svg class="icon icon-find-location" role="presentation" focusable="false" aria-hidden="true">
                            <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-find-location"></use>
                        </svg>
                        Find a Location
                    </h2>

                    <div class="form-group">
                        <label for="serviceSelect">Filter by Service</label>
                        <Select id='serviceSelect'
                            value={Services.filter(function (option) {
                                return option.value === ServiceFilter
                            })}
                            onChange={HandleTypeSelect}
                            options={Services}
                            classNamePrefix="locations-select"
                        />
                    </div>

                    <div class="form-group">
                        <label for="location-search-text">Search By</label>
                        <input value={Address} onChange={HandleAddressChange} onKeyDown={keyPress} id="location-search-text" type="text" class="form-control" placeholder="enter name, zip, address..." />
                    </div>

                    <button onClick={GetGeoCoordinates} type="button" class="locator__geo">
                        <svg class="icon icon-location" role="presentation" focusable="false" aria-hidden="true">
                            <use href="/ResourcePackages/Talon/assets/dist/sprites/svgdefs.svg#icon-location"></use>
                        </svg>
                         Use My Location
                    </button>
                    
                    <div class="locator__actions">
                        <button onClick={SearchLocations.bind(this,1)} type="button" class="button button--outline-alt locator__search-btn">
                            { GetButtonTitle() }
                        </button>
                    </div>

                </div>
            </div>
            <div class="locator__map">
                <GoogleMapReact
                    bootstrapURLKeys={{ key: LocationSettings.map }}
                    defaultZoom={MapZoom}
                    defaultCenter={MapCenter}>
                    {
                        (result && result.Locations && result.Locations.length > 0 ?
                            result.Locations.map((item) => {
                                return (<MapMarkerComponent
                                    lat={item.Address.Latitude ?? 0}
                                    lng={item.Address.Longitude ?? 0}
                                    parameters={{ item: item, url: GetDetailPageUrl(item.UrlName)}}
                                />)

                            })
                            :
                            <div></div>)
                    }
                </GoogleMapReact>
            </div>
        </div>

        <div class="container">
            <div class="locator__results">
                <div class="locator__results-header">
                    <div class="locator__results-number">
                        {result ? result.TotalRecords + ' result' + (result.TotalRecords != 1 ? 's' : '') : ''}
                    </div>
                    <div class="locator__results-paging pagination__list">
                        {
                            result && result.TotalPages ?
                                DisplayPageNumbers(result && result.TotalPages ? result.TotalPages : 1, result && result.PageNumber ? result.PageNumber : 1) :
                                ''
                        }
                    </div>
                </div>
                <div class="locator__results-list">
                    {
                        (result && result.Locations && result.Locations.length > 0 ?
                            result.Locations.map((item) => {
                                return (
                                    <div class="locator__item">
                                        <div class="locator__item-distance">
                                            {parseFloat(item.Miles.toFixed(1)).toLocaleString('en-US')} <div class="locator__item-distance-text">Miles Away</div>
                                        </div>
                                        <div class="locator__item-image">
                                            {
                                                item.Image ?
                                                    <img src={item.Image.MediaUrl} class="locator__item-image" alt={item.Image.AlternativeText != "" ? item.Image.AlternativeText : item.Title} height={item.Image.Height} width={item.Image.Width} /> :
                                                    <img alt="" />
                                            }
                                        </div>
                                        <AddressComponent item={item}></AddressComponent>
                                        <PhoneNumberComponent item={item}></PhoneNumberComponent>
                                        <MoreDetailButtonComponent url={GetDetailPageUrl(item.UrlName)}></MoreDetailButtonComponent>
                                    </div>
                                )
                            })
                            :
                            <div>No results to show</div>
                        )
                    }
                </div>
                <div class="locator__results-paging pagination__list">
                    {DisplayPageNumbers(result && result.TotalPages ? result.TotalPages : 1, result && result.PageNumber ? result.PageNumber : 1)}
                </div>
            </div>
        </div>

    </div>
    );
};
export default Locations;
